export const DASHBOARD_ROUTING = [
    {
        path: '/dashboard',
        name: 'dashboard',
        meta: {
            auth: true,
            breadcrumb: [
                { name: 'Sản phẩm hot', pathName: 'dashboard', icon: 'fa fa-search' },
            ]
        },
        component: () => import('./Dashboard.vue'),
        redirect: { name: 'dashboard-index' },
        children: [
            { 
                path: '/bang-dieu-khien.html',
                name: 'dashboard-index',
                component: () => import('./components/MainDashboard.vue')
            },
            { 
                path: '/chi-tiet-san-pham.html',
                name: 'detail-product-index',
                component: () => import('./components/DetailProduct.vue')
            }
        ]
    }
];